export function formatBillNaira(amount: number) {
  return `₦${amount.toLocaleString('en-NG', { minimumFractionDigits: 0 })}`;
}

export function formatPlanName(name: string) {
  return name.replace(/\s*-\s*N[\d,.\s]+$/, '').trim();
}

export const BILL_AMOUNT_PRESETS = [1000, 2000, 5000, 10000, 20000, 50000] as const;

export const billInputClass =
  'w-full rounded-xl border border-gray-200 bg-white px-4 py-3 text-sm text-gray-900 outline-none transition focus:border-brand-500 focus:ring-2 focus:ring-brand-500/20';

export const billSelectClass =
  'w-full rounded-xl border border-gray-200 bg-white px-4 py-3 text-sm text-gray-900 outline-none transition focus:border-brand-500 focus:ring-2 focus:ring-brand-500/20';

export const billSelectedToggleClass =
  'border-secondary-500 bg-secondary-50 text-secondary-700';

export const billUnselectedToggleClass =
  'border-gray-200 bg-white text-gray-800 hover:border-gray-300';

export const billSelectedOptionClass =
  'border-secondary-500 bg-secondary-50 text-secondary-700';
